
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/wygeneruj-nowe-haslo",
      function () {
        return require("private-next-pages/moje-konto/wygeneruj-nowe-haslo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/wygeneruj-nowe-haslo"])
      });
    }
  